export const enum ContainersNames {
    FREE_SPINS_WRAPPER = 'FREE SPINS WRAPPER',
    REELS_WRAPPER = 'REELS WRAPPER',
    GAME_CONTAINER = 'GAME_CONTAINER',
    BACKGROUND_CONTAINER = 'BACKGROUND_CONTAINER',
    BOTTOM_UNMASKED_CONTAINER = 'BOTTOM_UNMASKED_CONTAINER',
    REELS_CONTAINER = 'REELS_CONTAINER',
    TOP_UNMASKED_CONTAINER = 'TOP_UNMASKED_CONTAINER',
    CROP_MASK = 'CROP_MASK',
    ANIMATION_WRAPPER = 'ANIMATION_WRAPPER',
    LOGO_CONTAINER = 'LOGO_CONTAINER',
    REEL_CONTAINER = 'REEL_CONTAINER',
    INTRO_ANIMATION_CONTAINER = 'INTRO_ANIMATION_CONTAINER',
    SPLASH_SCREEN_CONTAINER = 'SPLASH_SCREEN_CONTAINER',
    BUY_BONUS_CONTAINER = 'BUY_BONUS_CONTAINER',
    FREE_SPINS_COUNTER_CONTAINER = 'FREE_SPINS_COUNTER_CONTAINER',
    RESPIN_COUNTER_CONTAINER = 'RESPIN_COUNTER_CONTAINER',
    FREE_SPINS_SUMMARY_POPUPS_CONTAINER = 'FREE_SPINS_SUMMARY_POPUPS_CONTAINER',
    POPUPS_TRANSITION_CONTAINER = 'POPUPS_TRANSITION_CONTAINER',
    FEATURE_INTRO_POPUP_CONTAINER = 'FEATURE_INTRO_POPUP_CONTAINER',
    MAX_EXPOSURE_POPUP_CONTAINER = 'MAX_EXPOSURE_POPUP_CONTAINER',
    UNFINISHED_ROUND_POPUP_CONTAINER = 'UNFINISHED_ROUND_POPUP_CONTAINER',
    JACKPOT_LADDERS_CONTAINER = 'JACKPOT_LADDERS_CONTAINER',
    JACKPOT_BOX_CONTAINER = 'JACKPOT_BOX_CONTAINER',
    JACKPOT_POPUP_CONTAINER = 'JACKPOT_POPUP_CONTAINER',
    JACKPOT_UPGRADE_CONTAINER = 'JACKPOT_UPGRADE_CONTAINER',
}
